import xhr from "xhr";

export default function () {
    const formID = "newsletter-form";
    const formName = "Newsletter Signup";

    const gtmPush = () => {
        dataLayer.push({
            event: "Form Submit",
            formName: formName,
            formID: formID,
        });
    };
    
    const form = document.getElementById(formID);
    if (form) {
        form.addEventListener("submit", (e) => {
            e.preventDefault();

            const nameField = e.target.querySelector("[name=firstname]");
            const emailField = e.target.querySelector("[name=email]");

            const variables = {
                firstname: nameField.value,
                email: emailField.value,
            };

            const messageDom = form.querySelector(".message");
            messageDom.classList.remove("good");
            messageDom.classList.remove("error");
            xhr.post(
                form.dataset.action,
                { body: JSON.stringify(variables) },
                (error, resp) => {
                    const data = JSON.parse(resp.body);
                    if (data.success) {
                        messageDom.classList.add("good");
                        nameField.value = "";
                        emailField.value = "";
                        gtmPush();
                    } else {
                        messageDom.classList.add("error");
                    }
                    messageDom.innerHTML = data.message;
                }
            );
        });
    }
}
